import React from "react";
import { useTranslation } from "react-i18next";
import SignInModal from "src/components/modals/SignInModal";
import WordRotate from "src/utils/ui/magicui/word-rotate";
import AnimatedGridPattern from "src/utils/ui/magicui/animated-grid-pattern";
import { cn } from "src/utils/Utils";
import { StickyScroll } from "src/utils/ui/sticky-scroll-reveal";
import Loader from "src/components/loaders/Loader";
import Footer from "src/components/layout/Footer";
import { img1, img2, img3 } from "src/routes/assets_paths/AssetsPaths";
import { usePageNotFoundStore } from "src/store/layout/usePageNotFoundStore";

export default function LandingPage() {
  const { t } = useTranslation();

  const { loading, setLoading } = usePageNotFoundStore();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [setLoading]);

  if (loading) {
    return <Loader />;
  }

  const content = [
    {
      title: t("EnhancedSecurityAndReliability"),
      description: t("SAFFCloudProjectGoal"),
      content: (
        <div
          className="bg-cover bg-center bg-no-repeat h-full"
          style={{ backgroundImage: `url(${img1})` }}
        ></div>
      ),
    },
    {
      title: t("IncreasedAccessibility"),
      description: t("CrossDeviceAccessibility"),
      content: (
        <div
          className="bg-cover bg-center bg-no-repeat h-full"
          style={{ backgroundImage: `url(${img2})` }}
        ></div>
      ),
    },
    {
      title: t("ControlledSharingWithExternalStakeholders"),
      description: t("ControlledFileSharing"),
      content: (
        <div
          className="bg-cover bg-center bg-no-repeat h-full"
          style={{ backgroundImage: `url(${img3})` }}
        ></div>
      ),
    },
  ];

  return (
    <>
      <div>
        {/* </FadeText> */}
        <div className="relative flex h-[700px] w-full items-center justify-center overflow-hidden rounded-lg bg-background p-20">
          <div className="z-10 whitespace-pre-wrap text-center text-5xl font-medium text-black">
            <div className="flex justify-center items-center flex-wrap">
              {t("hero1")}
              <div>
                <WordRotate
                  className="text-5xl font-medium text-center text-success dark:text-white"
                  words={[t("trusted"), t("secure")]}
                />
              </div>
              {t("hero2")}
            </div>
            <div className="text-xl lg:text-2xl mt-6 font-light">
              {" "}
              {t("OfficialPlatformDescription")}{" "}
            </div>

            <div className="mt-8 md:mt-12">
              <SignInModal />
            </div>
          </div>
          <AnimatedGridPattern
            numSquares={30}
            maxOpacity={0.1}
            duration={2}
            repeatDelay={1}
            className={cn(
              "[mask-image:radial-gradient(500px_circle_at_center,white,transparent)]",
              "inset-x-0 inset-y-[-30%] h-[200%] skew-y-12"
            )}
          />
        </div>
        <div className="p-10 mt-10">
          <StickyScroll content={content} />
        </div>
      </div>

     <Footer />
    </>
  );
}
